import { Component } from 'react';
export default class DefaultInputCOntrol extends Component {
  render() {
    return null;
  }
}
